import React from "react";

const ROWS = [
  ["generated", "PIX agrupados gerados"], ["confirmed", "Confirmados"], ["awaiting_payment", "Aguardando pagamento"],
  ["in_reconciliation", "Em conciliação"], ["divergences", "Divergências financeiras"], ["old_links_paid", "Links antigos pagos"],
  ["reversed", "Estornos / chargebacks"],
];
const GLOBAL = [
  ["webhook_signature_failures", "Falhas de assinatura (total)"], ["webhook_signature_rejected", "Webhooks rejeitados"],
  ["webhook_processing_errors", "Erros de processamento de webhook"], ["fetch_errors", "Falhas de consulta ao provedor"],
  ["duplicate_attempts_blocked", "Tentativas de baixa duplicada bloqueadas"],
];

export const MetricsGrid = ({ metrics }) => (
  <section className="border border-[#EBE5DF] bg-white p-6" data-testid="pc-metrics-section">
    <h2 className="text-lg font-semibold mb-4">Indicadores</h2>
    <div className="grid md:grid-cols-2 gap-6">
      {["cris", "eletros"].map((bu) => (
        <div key={bu}>
          <div className="text-[10px] tracking-[0.2em] uppercase text-[#5C5A57] mb-2">{bu === "cris" ? "Cris Lingerie" : "Eletros"}</div>
          <dl className="grid grid-cols-2 gap-2">
            {ROWS.map(([k, l]) => (
              <div key={k} className="bg-[#FBF8F5] p-3">
                <dt className="text-[11px] text-[#5C5A57]">{l}</dt>
                <dd className="text-xl font-semibold" data-testid={`pc-metric-${bu}-${k}`}>{metrics[bu][k]}</dd>
              </div>
            ))}
          </dl>
        </div>
      ))}
    </div>
    <dl className="grid md:grid-cols-5 gap-2 mt-6">
      {GLOBAL.map(([k, l]) => (
        <div key={k} className="border border-[#EBE5DF] p-3">
          <dt className="text-[11px] text-[#5C5A57]">{l}</dt>
          <dd className="text-xl font-semibold" data-testid={`pc-metric-${k}`}>{metrics[k]}</dd>
        </div>
      ))}
    </dl>
  </section>
);
